import { action, makeObservable, observable } from 'mobx';
import { makePersistable } from 'mobx-persist-store';

interface PlaybookData {
  eg_nid: string;
  playbook_id: string;
  type_of_playbook: string;
}

export class ContractAiqStore {
  serviceAgreementId: string = '';
  documentSelected: string = '';
  playbookData: PlaybookData = {
    eg_nid: '',
    playbook_id: '',
    type_of_playbook: '',
  };
  spdAgreementId: string = '';
  contractId: string = '';
  planId: string = '';
  draftId: string = '';
  data: any = {};

  constructor() {
    makeObservable(this, {
      serviceAgreementId: observable,
      spdAgreementId: observable,
      documentSelected: observable,
      setDocumentSelected: action,
      setServiceAgreementId: action,
      setSpdAgreementId: action,
      removeContractData: action,
      playbookData: observable,
      setPlaybookData: action,
      contractId: observable,
      setContractId: action,
      draftId: observable,
      setDraftId: action,
      planId: observable,
      setPlanId: action,
      data: observable,
      setData: action,
    });
    makePersistable(this, {
      name: 'ContractAiqStore',
      properties: [
        'serviceAgreementId',
        'documentSelected',
        'playbookData',
        'spdAgreementId',
        'contractId',
        'planId',
        'draftId',
        'data',
      ],
      storage: window.localStorage,
    });
  }
  setServiceAgreementId(id: string) {
    this.serviceAgreementId = id;
  }

  setSpdAgreementId(id: string) {
    this.spdAgreementId = id;
  }

  setDocumentSelected(document: any) {
    this.documentSelected = document;
  }

  setPlaybookData(
    eg_nid: string,
    playbook_id: string,
    type_of_playbook: string,
  ) {
    this.playbookData = {
      eg_nid: eg_nid,
      playbook_id: playbook_id,
      type_of_playbook: type_of_playbook,
    };
  }

  removePlaybookData() {
    this.playbookData = {
      eg_nid: '',
      playbook_id: '',
      type_of_playbook: '',
    };
  }

  removeContractData() {
    this.serviceAgreementId = '';
  }

  setContractId(id: string) {
    this.contractId = id;
  }

  setDraftId(id: string) {
    this.draftId = id;
  }

  setPlanId(id: string) {
    this.planId = id;
  }

  setData(data: any) {
    this.data = data;
  }
}

export default ContractAiqStore;
